import React from 'react'
import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import SearchIcon from '@mui/icons-material/Search'

import { EDistributionChannelType } from '../../../../../types/distribution-channel'
import { ImageLinks, LogoTypeProvider } from '../../../../../constants/image-link'
import ClearIcon from '@mui/icons-material/Clear'


export interface IFilterMapped {
  page?: number;
  perPage?: number;
  name?: string;
  type?: EDistributionChannelType;
  url?: string;
}

interface FilterGroupProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void;
  onSearch: (filter: IFilterMapped) => void;
}

const menuItemsType = [
  {
    label: 'ทั้งหมด',
    value: 'all',
  },
  {
    label: 'Facebook',
    value: EDistributionChannelType.FACEBOOK,
  },
  {
    label: 'Tiktok',
    value: EDistributionChannelType.TIKTOK,
  },
  {
    label: 'Instagram',
    value: EDistributionChannelType.INSTAGRAM,
  },
  {
    label: 'Shopee',
    value: EDistributionChannelType.SHOPEE,
  },
  {
    label: 'Lazada',
    value: EDistributionChannelType.LAZADA,
  },
  {
    label: 'อื่นๆ',
    value: EDistributionChannelType.ETC,
  },
]

const DistributionChannelFilter = ({ filter, onFilterChange, onSearch }: FilterGroupProps) => {

  const { page, perPage, name, type, url } = filter

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} lg={3}>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          label={'ชื่อ'}
          fullWidth
          id="name"
          name="name"
          variant="filled"
          value={name ?? ''}
          onChange={(e) => onFilterChange({ ...filter, name: e.target.value })}
        />
      </Grid>
      <Grid item xs={12} lg={3}>
        <TextField
          fullWidth
          label="ลิงค์ช่องทาง"
          variant="filled"
          defaultValue={filter.url ?? undefined}
          onChange={(e) => onFilterChange({ ...filter, url: e.target.value })}
        />
      </Grid>
      <Grid item xs={12} lg={2}>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="type-label">ช่องทางการขาย</InputLabel>
          <Select
            id="type"
            name="type"
            labelId="type-label"
            defaultValue={filter.type ?? undefined}
            onChange={(e) => onFilterChange({ ...filter, type: e.target.value as EDistributionChannelType })}
          >
            {
              menuItemsType.map((item, index: number) => (
                <MenuItem value={item.value} key={index}>
                  {item.value && item.value !== 'all' &&
                    <img style={{ marginRight: 5 }}
                         src={ImageLinks[`LOGO_${item.value.toUpperCase()}` as LogoTypeProvider]}
                         alt="smallLogoSocial"
                         height={20} />
                  }
                  {item.label}
                </MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} lg={2}>
        <Button
          color="primary"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => onSearch(filter)}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
      <Grid item xs={4} lg={2}>
        <Button
          color="inherit"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<ClearIcon />}
          onClick={() => {
            onFilterChange({
              page,
              perPage,
              name: undefined,
              type: undefined,
              url: undefined,
            })
            onSearch({
              page,
              perPage,
              name: undefined,
              type: undefined,
              url: undefined,
            })
          }}
          sx={{ height: '100%' }}
        >
          รีเซ็ต
        </Button>
      </Grid>
    </Grid>
  )
}

export default DistributionChannelFilter
